import { Common, color } from '@stockbit/ui';
import If from 'global/ErrorHandlers/If';
import useClickOutside from 'hooks/useClickOutside';
import { useState } from 'react';
import styled from 'styled-components';

const { Text, Flex, Input } = Common;

const Container = styled.div`
  position: relative;
  width: 100%;
`;

const List = styled.div`
  position: absolute;
  top: 40px;
  left: 0;
  width: 100%;
  overflow: auto;
  border: 1px solid ${color.gainsboro};
  box-shadow: unset;
  background-color: ${color.light};
  border-radius: 2px;

  a {
    display: block;

    &:hover {
      background: ${color.gainsboro};
    }
  }
`;

const AutoSuggestion = ({ onSearch, options = [], onSelect, maxHeight }) => {
  const [open, setOpen] = useState<boolean>(false);
  const { ref } = useClickOutside(() => setOpen(false));

  return (
    <Container ref={ref}>
      <Input
        placeholder="Search..."
        height="30px"
        width="100%"
        onChange={onSearch}
        onFocus={() => setOpen(true)}
      />
      <If condition={open && options.length > 0}>
        <List style={{ maxHeight }}>
          {options.map((opt) => (
            <Flex
              as="a"
              onClick={() => {
                onSelect(opt);
              }}
            >
              <Text p="10px">{opt.name}</Text>
            </Flex>
          ))}
        </List>
      </If>
    </Container>
  );
};

export default AutoSuggestion;
